export default __webpack_public_path__ + "static/media/404.68a4955d.svg";